(() => {
  if (window.ttCardSwatchesReady) return;
  window.ttCardSwatchesReady = true;

  const applyImageAttrs = (image, src, srcset, width, height, alt) => {
    if (!image || !src) return;
    if (srcset) image.setAttribute('srcset', srcset);
    image.setAttribute('src', src);
    if (width) image.setAttribute('width', width);
    if (height) image.setAttribute('height', height);
    if (alt) image.setAttribute('alt', alt);
    image.style.opacity = '';
    image.removeAttribute('hidden');
  };

  const ensureSecondaryImage = (card, primary) => {
    let secondary = card.querySelector('[data-tt-card-image-secondary]');
    if (secondary || !primary || !primary.parentNode) return secondary;

    secondary = primary.cloneNode(true);
    secondary.removeAttribute('data-tt-card-image');
    secondary.removeAttribute('fetchpriority');
    secondary.setAttribute('data-tt-card-image-secondary', '');
    secondary.setAttribute('loading', 'lazy');
    primary.parentNode.appendChild(secondary);
    return secondary;
  };

  const applySwatch = (swatch) => {
    const card = swatch.closest('[data-tt-swatchable-card]');
    if (!card) return;

    card.querySelectorAll('[data-tt-card-swatch]').forEach((btn) => {
      const isActive = btn === swatch;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    const primary = card.querySelector('[data-tt-card-image]');
    applyImageAttrs(
      primary,
      swatch.dataset.imageSrc,
      swatch.dataset.imageSrcset,
      swatch.dataset.imageWidth,
      swatch.dataset.imageHeight,
      swatch.dataset.imageAlt
    );

    const hasSecondary = Boolean(swatch.dataset.secondaryImageSrc);
    let secondary = card.querySelector('[data-tt-card-image-secondary]');

    if (hasSecondary) {
      secondary = ensureSecondaryImage(card, primary) || secondary;
      if (secondary) secondary.removeAttribute('hidden');
      applyImageAttrs(
        secondary,
        swatch.dataset.secondaryImageSrc,
        swatch.dataset.secondaryImageSrcset,
        swatch.dataset.secondaryImageWidth,
        swatch.dataset.secondaryImageHeight,
        swatch.dataset.secondaryImageAlt
      );
      card.classList.remove('is-swatch-selected');
    } else if (secondary) {
      secondary.setAttribute('hidden', '');
      card.classList.add('is-swatch-selected');
    } else {
      card.classList.add('is-swatch-selected');
    }

    const variantUrl = swatch.dataset.variantUrl;
    if (!variantUrl) return;

    const baseUrl = variantUrl.split('#')[0];
    card.querySelectorAll('[data-tt-card-product-link]').forEach((link) => {
      const linkType = link.getAttribute('data-tt-card-product-link');
      if (linkType === 'reviews') {
        link.setAttribute('href', `${baseUrl}#judgeme_product_reviews`);
        return;
      }
      link.setAttribute('href', baseUrl);
    });
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-tt-card-swatch]');
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();
    applySwatch(swatch);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const swatch = event.target.closest('[data-tt-card-swatch]');
    if (!swatch) return;

    event.preventDefault();
    applySwatch(swatch);
  });

  // Sync card images + links to the active swatch on load (first color after refresh).
  const syncActiveSwatches = (root = document) => {
    root.querySelectorAll('[data-tt-swatchable-card]').forEach((card) => {
      const active =
        card.querySelector('[data-tt-card-swatch].is-active') ||
        card.querySelector('[data-tt-card-swatch]');
      if (active && active.dataset.imageSrc) applySwatch(active);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncActiveSwatches(), { once: true });
  } else {
    syncActiveSwatches();
  }

  // Facet filters replace #ProductGridContainer via AJAX — re-apply gallery heroes.
  const observeProductGrid = () => {
    const grid = document.getElementById('ProductGridContainer');
    if (!grid || grid.dataset.ttSwatchSyncBound === 'true') return;
    grid.dataset.ttSwatchSyncBound = 'true';
    let timer = 0;
    const observer = new MutationObserver(() => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => syncActiveSwatches(grid), 0);
    });
    observer.observe(grid, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeProductGrid, { once: true });
  } else {
    observeProductGrid();
  }
})();
